// GENERATED by scripts/gen-content.ts — do not edit. Run: bun run gen
// Static JSON imports so both the browser bundle and the headless Bun server
// load content through one path (no runtime fs on either side).

import quests_soft_landing_json from "../../content/quests/soft-landing.json";
import quests_wolf_hunt_json from "../../content/quests/wolf-hunt.json";
import npcs_angler_json from "../../content/npcs/angler.json";
import npcs_boat_json from "../../content/npcs/boat.json";
import npcs_boatman_json from "../../content/npcs/boatman.json";
import npcs_bram_json from "../../content/npcs/bram.json";
import npcs_chicken_json from "../../content/npcs/chicken.json";
import npcs_cook_json from "../../content/npcs/cook.json";
import npcs_cow_json from "../../content/npcs/cow.json";
import npcs_deer_json from "../../content/npcs/deer.json";
import npcs_dekkar_json from "../../content/npcs/dekkar.json";
import npcs_edric_json from "../../content/npcs/edric.json";
import npcs_fishmonger_json from "../../content/npcs/fishmonger.json";
import npcs_fox_json from "../../content/npcs/fox.json";
import npcs_goblin_archer_json from "../../content/npcs/goblin-archer.json";
import npcs_goblin_json from "../../content/npcs/goblin.json";
import npcs_grizzlespit_json from "../../content/npcs/grizzlespit.json";
import npcs_guard_json from "../../content/npcs/guard.json";
import npcs_horse_json from "../../content/npcs/horse.json";
import npcs_huntsman_json from "../../content/npcs/huntsman.json";
import npcs_king_json from "../../content/npcs/king.json";
import npcs_lila_json from "../../content/npcs/lila.json";
import npcs_mira_json from "../../content/npcs/mira.json";
import npcs_pig_json from "../../content/npcs/pig.json";
import npcs_rabbit_json from "../../content/npcs/rabbit.json";
import npcs_scrawny_wolf_json from "../../content/npcs/scrawny-wolf.json";
import npcs_sheep_json from "../../content/npcs/sheep.json";
import npcs_shopkeeper_json from "../../content/npcs/shopkeeper.json";
import npcs_spider_json from "../../content/npcs/spider.json";
import npcs_storekeeper_json from "../../content/npcs/storekeeper.json";
import npcs_tanner_json from "../../content/npcs/tanner.json";
import npcs_wolf_json from "../../content/npcs/wolf.json";
import items_ale_json from "../../content/items/ale.json";
import items_axe_json from "../../content/items/axe.json";
import items_backpack_json from "../../content/items/backpack.json";
import items_birch_logs_json from "../../content/items/birch-logs.json";
import items_burnt_mess_json from "../../content/items/burnt-mess.json";
import items_chain_boots_elite_json from "../../content/items/chain-boots-elite.json";
import items_chain_boots_trimmed_json from "../../content/items/chain-boots-trimmed.json";
import items_chain_boots_json from "../../content/items/chain-boots.json";
import items_chain_chausses_elite_json from "../../content/items/chain-chausses-elite.json";
import items_chain_chausses_trimmed_json from "../../content/items/chain-chausses-trimmed.json";
import items_chain_chausses_json from "../../content/items/chain-chausses.json";
import items_chain_coif_elite_json from "../../content/items/chain-coif-elite.json";
import items_chain_coif_trimmed_json from "../../content/items/chain-coif-trimmed.json";
import items_chain_coif_json from "../../content/items/chain-coif.json";
import items_chain_hauberk_elite_json from "../../content/items/chain-hauberk-elite.json";
import items_chain_hauberk_trimmed_json from "../../content/items/chain-hauberk-trimmed.json";
import items_chain_hauberk_json from "../../content/items/chain-hauberk.json";
import items_cloak_json from "../../content/items/cloak.json";
import items_cloth_pants_json from "../../content/items/cloth-pants.json";
import items_cooked_meat_json from "../../content/items/cooked-meat.json";
import items_cooked_minnow_json from "../../content/items/cooked-minnow.json";
import items_cooked_perch_json from "../../content/items/cooked-perch.json";
import items_cooked_pike_json from "../../content/items/cooked-pike.json";
import items_cooked_trout_json from "../../content/items/cooked-trout.json";
import items_cooked_venison_json from "../../content/items/cooked-venison.json";
import items_cup_json from "../../content/items/cup.json";
import items_fermenter_json from "../../content/items/fermenter.json";
import items_fishing_net_json from "../../content/items/fishing-net.json";
import items_fishing_rod_json from "../../content/items/fishing-rod.json";
import items_flower_json from "../../content/items/flower.json";
import items_goblin_token_json from "../../content/items/goblin-token.json";
import items_greatsword_json from "../../content/items/greatsword.json";
import items_hatchet_json from "../../content/items/hatchet.json";
import items_hide_json from "../../content/items/hide.json";
import items_hooded_cloak_json from "../../content/items/hooded-cloak.json";
import items_hunting_bow_json from "../../content/items/hunting-bow.json";
import items_iron_boots_json from "../../content/items/iron-boots.json";
import items_iron_helm_json from "../../content/items/iron-helm.json";
import items_kindling_json from "../../content/items/kindling.json";
import items_leather_boots_elite_json from "../../content/items/leather-boots-elite.json";
import items_leather_boots_trimmed_json from "../../content/items/leather-boots-trimmed.json";
import items_leather_boots_json from "../../content/items/leather-boots.json";
import items_leather_cap_elite_json from "../../content/items/leather-cap-elite.json";
import items_leather_cap_trimmed_json from "../../content/items/leather-cap-trimmed.json";
import items_leather_cap_json from "../../content/items/leather-cap.json";
import items_leather_greaves_elite_json from "../../content/items/leather-greaves-elite.json";
import items_leather_greaves_trimmed_json from "../../content/items/leather-greaves-trimmed.json";
import items_leather_greaves_json from "../../content/items/leather-greaves.json";
import items_leather_jerkin_elite_json from "../../content/items/leather-jerkin-elite.json";
import items_leather_jerkin_trimmed_json from "../../content/items/leather-jerkin-trimmed.json";
import items_leather_jerkin_json from "../../content/items/leather-jerkin.json";
import items_leather_shoes_json from "../../content/items/leather-shoes.json";
import items_longbow_json from "../../content/items/longbow.json";
import items_minnow_json from "../../content/items/minnow.json";
import items_oak_logs_json from "../../content/items/oak-logs.json";
import items_obol_json from "../../content/items/obol.json";
import items_padded_chausses_elite_json from "../../content/items/padded-chausses-elite.json";
import items_padded_chausses_trimmed_json from "../../content/items/padded-chausses-trimmed.json";
import items_padded_chausses_json from "../../content/items/padded-chausses.json";
import items_padded_coif_elite_json from "../../content/items/padded-coif-elite.json";
import items_padded_coif_trimmed_json from "../../content/items/padded-coif-trimmed.json";
import items_padded_coif_json from "../../content/items/padded-coif.json";
import items_padded_jack_elite_json from "../../content/items/padded-jack-elite.json";
import items_padded_jack_trimmed_json from "../../content/items/padded-jack-trimmed.json";
import items_padded_jack_json from "../../content/items/padded-jack.json";
import items_padded_shoes_elite_json from "../../content/items/padded-shoes-elite.json";
import items_padded_shoes_trimmed_json from "../../content/items/padded-shoes-trimmed.json";
import items_padded_shoes_json from "../../content/items/padded-shoes.json";
import items_perch_json from "../../content/items/perch.json";
import items_pike_json from "../../content/items/pike.json";
import items_pine_logs_json from "../../content/items/pine-logs.json";
import items_pinecone_json from "../../content/items/pinecone.json";
import items_plate_boots_elite_json from "../../content/items/plate-boots-elite.json";
import items_plate_boots_trimmed_json from "../../content/items/plate-boots-trimmed.json";
import items_plate_cuirass_elite_json from "../../content/items/plate-cuirass-elite.json";
import items_plate_cuirass_trimmed_json from "../../content/items/plate-cuirass-trimmed.json";
import items_plate_cuirass_json from "../../content/items/plate-cuirass.json";
import items_plate_greaves_elite_json from "../../content/items/plate-greaves-elite.json";
import items_plate_greaves_trimmed_json from "../../content/items/plate-greaves-trimmed.json";
import items_plate_greaves_json from "../../content/items/plate-greaves.json";
import items_plate_helm_elite_json from "../../content/items/plate-helm-elite.json";
import items_plate_helm_trimmed_json from "../../content/items/plate-helm-trimmed.json";
import items_preserves_json from "../../content/items/preserves.json";
import items_raw_meat_json from "../../content/items/raw-meat.json";
import items_round_shield_json from "../../content/items/round-shield.json";
import items_rusty_sword_json from "../../content/items/rusty-sword.json";
import items_scout_harness_elite_json from "../../content/items/scout-harness-elite.json";
import items_scout_harness_trimmed_json from "../../content/items/scout-harness-trimmed.json";
import items_scout_harness_json from "../../content/items/scout-harness.json";
import items_scout_hood_elite_json from "../../content/items/scout-hood-elite.json";
import items_scout_hood_trimmed_json from "../../content/items/scout-hood-trimmed.json";
import items_scout_hood_json from "../../content/items/scout-hood.json";
import items_scout_wraps_elite_json from "../../content/items/scout-wraps-elite.json";
import items_scout_wraps_trimmed_json from "../../content/items/scout-wraps-trimmed.json";
import items_scout_wraps_json from "../../content/items/scout-wraps.json";
import items_shortbow_json from "../../content/items/shortbow.json";
import items_shorts_json from "../../content/items/shorts.json";
import items_silver_fox_pelt_json from "../../content/items/silver-fox-pelt.json";
import items_snare_trap_json from "../../content/items/snare-trap.json";
import items_spear_json from "../../content/items/spear.json";
import items_stag_antlers_json from "../../content/items/stag-antlers.json";
import items_straw_hat_json from "../../content/items/straw-hat.json";
import items_sword_json from "../../content/items/sword.json";
import items_trail_shoes_elite_json from "../../content/items/trail-shoes-elite.json";
import items_trail_shoes_trimmed_json from "../../content/items/trail-shoes-trimmed.json";
import items_trail_shoes_json from "../../content/items/trail-shoes.json";
import items_trout_json from "../../content/items/trout.json";
import items_tunic_short_json from "../../content/items/tunic-short.json";
import items_tunic_json from "../../content/items/tunic.json";
import items_venison_json from "../../content/items/venison.json";
import items_wooden_arrow_json from "../../content/items/wooden-arrow.json";
import items_wooden_bow_json from "../../content/items/wooden-bow.json";
import items_wool_cape_json from "../../content/items/wool-cape.json";
import models_ale_json from "../../content/models/ale.json";
import models_angler_json from "../../content/models/angler.json";
import models_axe_json from "../../content/models/axe.json";
import models_birch_logs_json from "../../content/models/birch-logs.json";
import models_boat_json from "../../content/models/boat.json";
import models_boatman_json from "../../content/models/boatman.json";
import models_bram_json from "../../content/models/bram.json";
import models_burnt_mess_json from "../../content/models/burnt-mess.json";
import models_chicken_json from "../../content/models/chicken.json";
import models_cloth_pants_json from "../../content/models/cloth-pants.json";
import models_cooked_meat_json from "../../content/models/cooked-meat.json";
import models_cooked_minnow_json from "../../content/models/cooked-minnow.json";
import models_cooked_perch_json from "../../content/models/cooked-perch.json";
import models_cooked_pike_json from "../../content/models/cooked-pike.json";
import models_cooked_trout_json from "../../content/models/cooked-trout.json";
import models_cooked_venison_json from "../../content/models/cooked-venison.json";
import models_cow_json from "../../content/models/cow.json";
import models_cup_json from "../../content/models/cup.json";
import models_deer_json from "../../content/models/deer.json";
import models_dekkar_json from "../../content/models/dekkar.json";
import models_fermenter_json from "../../content/models/fermenter.json";
import models_fishing_net_json from "../../content/models/fishing-net.json";
import models_fishing_rod_json from "../../content/models/fishing-rod.json";
import models_fishmonger_json from "../../content/models/fishmonger.json";
import models_fox_json from "../../content/models/fox.json";
import models_goblin_archer_json from "../../content/models/goblin-archer.json";
import models_goblin_token_json from "../../content/models/goblin-token.json";
import models_goblin_json from "../../content/models/goblin.json";
import models_greatsword_json from "../../content/models/greatsword.json";
import models_hatchet_json from "../../content/models/hatchet.json";
import models_hide_json from "../../content/models/hide.json";
import models_horse_json from "../../content/models/horse.json";
import models_hunting_bow_json from "../../content/models/hunting-bow.json";
import models_huntsman_json from "../../content/models/huntsman.json";
import models_kindling_json from "../../content/models/kindling.json";
import models_king_json from "../../content/models/king.json";
import models_leather_shoes_json from "../../content/models/leather-shoes.json";
import models_lila_json from "../../content/models/lila.json";
import models_longbow_json from "../../content/models/longbow.json";
import models_minnow_json from "../../content/models/minnow.json";
import models_mira_json from "../../content/models/mira.json";
import models_oak_logs_json from "../../content/models/oak-logs.json";
import models_obol_json from "../../content/models/obol.json";
import models_perch_json from "../../content/models/perch.json";
import models_pig_json from "../../content/models/pig.json";
import models_pike_json from "../../content/models/pike.json";
import models_pine_logs_json from "../../content/models/pine-logs.json";
import models_pinecone_json from "../../content/models/pinecone.json";
import models_player_json from "../../content/models/player.json";
import models_preserves_json from "../../content/models/preserves.json";
import models_rabbit_json from "../../content/models/rabbit.json";
import models_raw_meat_json from "../../content/models/raw-meat.json";
import models_round_shield_json from "../../content/models/round-shield.json";
import models_rusty_sword_json from "../../content/models/rusty-sword.json";
import models_sheep_json from "../../content/models/sheep.json";
import models_shopkeeper_json from "../../content/models/shopkeeper.json";
import models_shortbow_json from "../../content/models/shortbow.json";
import models_shorts_json from "../../content/models/shorts.json";
import models_silver_fox_pelt_json from "../../content/models/silver-fox-pelt.json";
import models_snare_trap_json from "../../content/models/snare-trap.json";
import models_spear_json from "../../content/models/spear.json";
import models_spider_json from "../../content/models/spider.json";
import models_stag_antlers_json from "../../content/models/stag-antlers.json";
import models_storekeeper_json from "../../content/models/storekeeper.json";
import models_sword_json from "../../content/models/sword.json";
import models_tanner_json from "../../content/models/tanner.json";
import models_town_guard_json from "../../content/models/town-guard.json";
import models_townsman_json from "../../content/models/townsman.json";
import models_trout_json from "../../content/models/trout.json";
import models_tunic_short_json from "../../content/models/tunic-short.json";
import models_tunic_json from "../../content/models/tunic.json";
import models_venison_json from "../../content/models/venison.json";
import models_villager_json from "../../content/models/villager.json";
import models_wolf_json from "../../content/models/wolf.json";
import models_wooden_arrow_json from "../../content/models/wooden-arrow.json";
import models_wooden_bow_json from "../../content/models/wooden-bow.json";
import decos_barrel_json from "../../content/decos/barrel.json";
import decos_bench_json from "../../content/decos/bench.json";
import decos_birch_json from "../../content/decos/birch.json";
import decos_boulder_json from "../../content/decos/boulder.json";
import decos_bush_json from "../../content/decos/bush.json";
import decos_campfire_json from "../../content/decos/campfire.json";
import decos_cattail_json from "../../content/decos/cattail.json";
import decos_chest_json from "../../content/decos/chest.json";
import decos_crate_json from "../../content/decos/crate.json";
import decos_driftwood_json from "../../content/decos/driftwood.json";
import decos_drying_rack_json from "../../content/decos/drying-rack.json";
import decos_fence_json from "../../content/decos/fence.json";
import decos_fern_json from "../../content/decos/fern.json";
import decos_flower_json from "../../content/decos/flower.json";
import decos_grass_json from "../../content/decos/grass.json";
import decos_hanging_net_json from "../../content/decos/hanging-net.json";
import decos_hide_frame_json from "../../content/decos/hide-frame.json";
import decos_lantern_post_json from "../../content/decos/lantern-post.json";
import decos_laundry_line_json from "../../content/decos/laundry-line.json";
import decos_lilypad_json from "../../content/decos/lilypad.json";
import decos_log_json from "../../content/decos/log.json";
import decos_mushroom_json from "../../content/decos/mushroom.json";
import decos_net_shed_json from "../../content/decos/net-shed.json";
import decos_notice_board_json from "../../content/decos/notice-board.json";
import decos_pine_json from "../../content/decos/pine.json";
import decos_planter_json from "../../content/decos/planter.json";
import decos_rain_barrel_json from "../../content/decos/rain-barrel.json";
import decos_range_json from "../../content/decos/range.json";
import decos_rock_json from "../../content/decos/rock.json";
import decos_signpost_json from "../../content/decos/signpost.json";
import decos_stump_json from "../../content/decos/stump.json";
import decos_tree_json from "../../content/decos/tree.json";
import decos_well_json from "../../content/decos/well.json";
import decos_woodpile_json from "../../content/decos/woodpile.json";
import parts_backpack_json from "../../content/parts/backpack.json";
import parts_beard_gray_json from "../../content/parts/beard-gray.json";
import parts_beard_white_json from "../../content/parts/beard-white.json";
import parts_chain_boots_elite_json from "../../content/parts/chain-boots-elite.json";
import parts_chain_boots_trimmed_json from "../../content/parts/chain-boots-trimmed.json";
import parts_chain_boots_json from "../../content/parts/chain-boots.json";
import parts_chain_chausses_elite_json from "../../content/parts/chain-chausses-elite.json";
import parts_chain_chausses_trimmed_json from "../../content/parts/chain-chausses-trimmed.json";
import parts_chain_chausses_json from "../../content/parts/chain-chausses.json";
import parts_chain_coif_elite_json from "../../content/parts/chain-coif-elite.json";
import parts_chain_coif_trimmed_json from "../../content/parts/chain-coif-trimmed.json";
import parts_chain_coif_json from "../../content/parts/chain-coif.json";
import parts_chain_hauberk_elite_json from "../../content/parts/chain-hauberk-elite.json";
import parts_chain_hauberk_trimmed_json from "../../content/parts/chain-hauberk-trimmed.json";
import parts_chain_hauberk_json from "../../content/parts/chain-hauberk.json";
import parts_cloak_json from "../../content/parts/cloak.json";
import parts_goblin_face_json from "../../content/parts/goblin-face.json";
import parts_gold_crown_json from "../../content/parts/gold-crown.json";
import parts_hooded_cloak_json from "../../content/parts/hooded-cloak.json";
import parts_iron_boots_json from "../../content/parts/iron-boots.json";
import parts_iron_helm_json from "../../content/parts/iron-helm.json";
import parts_leather_boots_elite_json from "../../content/parts/leather-boots-elite.json";
import parts_leather_boots_trimmed_json from "../../content/parts/leather-boots-trimmed.json";
import parts_leather_boots_json from "../../content/parts/leather-boots.json";
import parts_leather_cap_elite_json from "../../content/parts/leather-cap-elite.json";
import parts_leather_cap_trimmed_json from "../../content/parts/leather-cap-trimmed.json";
import parts_leather_cap_json from "../../content/parts/leather-cap.json";
import parts_leather_greaves_elite_json from "../../content/parts/leather-greaves-elite.json";
import parts_leather_greaves_trimmed_json from "../../content/parts/leather-greaves-trimmed.json";
import parts_leather_greaves_json from "../../content/parts/leather-greaves.json";
import parts_leather_jerkin_elite_json from "../../content/parts/leather-jerkin-elite.json";
import parts_leather_jerkin_trimmed_json from "../../content/parts/leather-jerkin-trimmed.json";
import parts_leather_jerkin_json from "../../content/parts/leather-jerkin.json";
import parts_padded_chausses_elite_json from "../../content/parts/padded-chausses-elite.json";
import parts_padded_chausses_trimmed_json from "../../content/parts/padded-chausses-trimmed.json";
import parts_padded_chausses_json from "../../content/parts/padded-chausses.json";
import parts_padded_coif_elite_json from "../../content/parts/padded-coif-elite.json";
import parts_padded_coif_trimmed_json from "../../content/parts/padded-coif-trimmed.json";
import parts_padded_coif_json from "../../content/parts/padded-coif.json";
import parts_padded_jack_elite_json from "../../content/parts/padded-jack-elite.json";
import parts_padded_jack_trimmed_json from "../../content/parts/padded-jack-trimmed.json";
import parts_padded_jack_json from "../../content/parts/padded-jack.json";
import parts_padded_shoes_elite_json from "../../content/parts/padded-shoes-elite.json";
import parts_padded_shoes_trimmed_json from "../../content/parts/padded-shoes-trimmed.json";
import parts_padded_shoes_json from "../../content/parts/padded-shoes.json";
import parts_plate_boots_elite_json from "../../content/parts/plate-boots-elite.json";
import parts_plate_boots_trimmed_json from "../../content/parts/plate-boots-trimmed.json";
import parts_plate_cuirass_elite_json from "../../content/parts/plate-cuirass-elite.json";
import parts_plate_cuirass_trimmed_json from "../../content/parts/plate-cuirass-trimmed.json";
import parts_plate_cuirass_json from "../../content/parts/plate-cuirass.json";
import parts_plate_greaves_elite_json from "../../content/parts/plate-greaves-elite.json";
import parts_plate_greaves_trimmed_json from "../../content/parts/plate-greaves-trimmed.json";
import parts_plate_greaves_json from "../../content/parts/plate-greaves.json";
import parts_plate_helm_elite_json from "../../content/parts/plate-helm-elite.json";
import parts_plate_helm_trimmed_json from "../../content/parts/plate-helm-trimmed.json";
import parts_plumed_helm_json from "../../content/parts/plumed-helm.json";
import parts_royal_cape_json from "../../content/parts/royal-cape.json";
import parts_scout_harness_elite_json from "../../content/parts/scout-harness-elite.json";
import parts_scout_harness_trimmed_json from "../../content/parts/scout-harness-trimmed.json";
import parts_scout_harness_json from "../../content/parts/scout-harness.json";
import parts_scout_hood_elite_json from "../../content/parts/scout-hood-elite.json";
import parts_scout_hood_trimmed_json from "../../content/parts/scout-hood-trimmed.json";
import parts_scout_hood_json from "../../content/parts/scout-hood.json";
import parts_scout_wraps_elite_json from "../../content/parts/scout-wraps-elite.json";
import parts_scout_wraps_trimmed_json from "../../content/parts/scout-wraps-trimmed.json";
import parts_scout_wraps_json from "../../content/parts/scout-wraps.json";
import parts_straw_hat_json from "../../content/parts/straw-hat.json";
import parts_trail_shoes_elite_json from "../../content/parts/trail-shoes-elite.json";
import parts_trail_shoes_trimmed_json from "../../content/parts/trail-shoes-trimmed.json";
import parts_trail_shoes_json from "../../content/parts/trail-shoes.json";
import parts_wool_cape_json from "../../content/parts/wool-cape.json";
import structures_chapel_json from "../../content/structures/chapel.json";
import structures_fishing_dock_json from "../../content/structures/fishing-dock.json";
import structures_general_store_json from "../../content/structures/general-store.json";
import structures_log_house_json from "../../content/structures/log-house.json";
import structures_market_pavilion_json from "../../content/structures/market-pavilion.json";
import structures_shed_json from "../../content/structures/shed.json";
import structures_standard_house_json from "../../content/structures/standard-house.json";
import structures_stone_arch_json from "../../content/structures/stone-arch.json";
import shops_castle_armory_json from "../../content/shops/castle-armory.json";
import shops_fish_market_json from "../../content/shops/fish-market.json";
import shops_general_store_json from "../../content/shops/general-store.json";
import shops_huntsman_lodge_json from "../../content/shops/huntsman-lodge.json";
import shops_kitchen_json from "../../content/shops/kitchen.json";
import skills_combat_json from "../../content/skills/combat.json";
import skills_cooking_json from "../../content/skills/cooking.json";
import skills_fishing_json from "../../content/skills/fishing.json";
import skills_hunting_json from "../../content/skills/hunting.json";
import standing_cooks_json from "../../content/standing/cooks.json";
import standing_crown_json from "../../content/standing/crown.json";
import standing_fishmongers_json from "../../content/standing/fishmongers.json";
import standing_huntsmen_json from "../../content/standing/huntsmen.json";
import moves_bash_json from "../../content/moves/bash.json";
import moves_heavy_strike_json from "../../content/moves/heavy-strike.json";
import moves_leg_sweep_json from "../../content/moves/leg-sweep.json";
import moves_pierce_json from "../../content/moves/pierce.json";
import moves_power_shot_json from "../../content/moves/power-shot.json";
import moves_shove_json from "../../content/moves/shove.json";
import moves_slow_arrow_json from "../../content/moves/slow-arrow.json";
import moves_sweep_json from "../../content/moves/sweep.json";
import moves_whirl_json from "../../content/moves/whirl.json";
import scenarios_archer_ambush_json from "../../content/scenarios/archer-ambush.json";
import scenarios_goblin_camp_json from "../../content/scenarios/goblin-camp.json";
import scenarios_guard_rescue_json from "../../content/scenarios/guard-rescue.json";
import cinematics_boat_arrival_json from "../../content/cinematics/boat-arrival.json";
import catch_tables_netting_bulk_json from "../../content/catch-tables/netting-bulk.json";
import scatter_palettes_forest_json from "../../content/scatter-palettes/forest.json";
import scatter_palettes_rocky_scrub_json from "../../content/scatter-palettes/rocky-scrub.json";
import tunables_chopping_json from "../../content/tunables/chopping.json";
import tunables_cooking_json from "../../content/tunables/cooking.json";
import tunables_firestarting_json from "../../content/tunables/firestarting.json";
import tunables_fishing_json from "../../content/tunables/fishing.json";
import tunables_hunting_json from "../../content/tunables/hunting.json";
import maps_arena_test_json from "../../content/maps/arena-test.json";
import maps_east_marches_json from "../../content/maps/east-marches.json";
import maps_overworld_json from "../../content/maps/overworld.json";
import maps_testing_json from "../../content/maps/testing.json";
import maps_tutorial_south_json from "../../content/maps/tutorial-south.json";
import maps_tutorial_west_json from "../../content/maps/tutorial-west.json";
import maps_tutorial_json from "../../content/maps/tutorial.json";
import world_factions_json from "../../content/world/factions.json";
import anim_clips_json from "../../content/anim/clips.json";

export type RawEntry = { file: string; data: unknown };

export const RAW = {
  "quests": [
    { file: "content/quests/soft-landing.json", data: quests_soft_landing_json },
    { file: "content/quests/wolf-hunt.json", data: quests_wolf_hunt_json },
  ] as RawEntry[],
  "npcs": [
    { file: "content/npcs/angler.json", data: npcs_angler_json },
    { file: "content/npcs/boat.json", data: npcs_boat_json },
    { file: "content/npcs/boatman.json", data: npcs_boatman_json },
    { file: "content/npcs/bram.json", data: npcs_bram_json },
    { file: "content/npcs/chicken.json", data: npcs_chicken_json },
    { file: "content/npcs/cook.json", data: npcs_cook_json },
    { file: "content/npcs/cow.json", data: npcs_cow_json },
    { file: "content/npcs/deer.json", data: npcs_deer_json },
    { file: "content/npcs/dekkar.json", data: npcs_dekkar_json },
    { file: "content/npcs/edric.json", data: npcs_edric_json },
    { file: "content/npcs/fishmonger.json", data: npcs_fishmonger_json },
    { file: "content/npcs/fox.json", data: npcs_fox_json },
    { file: "content/npcs/goblin-archer.json", data: npcs_goblin_archer_json },
    { file: "content/npcs/goblin.json", data: npcs_goblin_json },
    { file: "content/npcs/grizzlespit.json", data: npcs_grizzlespit_json },
    { file: "content/npcs/guard.json", data: npcs_guard_json },
    { file: "content/npcs/horse.json", data: npcs_horse_json },
    { file: "content/npcs/huntsman.json", data: npcs_huntsman_json },
    { file: "content/npcs/king.json", data: npcs_king_json },
    { file: "content/npcs/lila.json", data: npcs_lila_json },
    { file: "content/npcs/mira.json", data: npcs_mira_json },
    { file: "content/npcs/pig.json", data: npcs_pig_json },
    { file: "content/npcs/rabbit.json", data: npcs_rabbit_json },
    { file: "content/npcs/scrawny-wolf.json", data: npcs_scrawny_wolf_json },
    { file: "content/npcs/sheep.json", data: npcs_sheep_json },
    { file: "content/npcs/shopkeeper.json", data: npcs_shopkeeper_json },
    { file: "content/npcs/spider.json", data: npcs_spider_json },
    { file: "content/npcs/storekeeper.json", data: npcs_storekeeper_json },
    { file: "content/npcs/tanner.json", data: npcs_tanner_json },
    { file: "content/npcs/wolf.json", data: npcs_wolf_json },
  ] as RawEntry[],
  "items": [
    { file: "content/items/ale.json", data: items_ale_json },
    { file: "content/items/axe.json", data: items_axe_json },
    { file: "content/items/backpack.json", data: items_backpack_json },
    { file: "content/items/birch-logs.json", data: items_birch_logs_json },
    { file: "content/items/burnt-mess.json", data: items_burnt_mess_json },
    { file: "content/items/chain-boots-elite.json", data: items_chain_boots_elite_json },
    { file: "content/items/chain-boots-trimmed.json", data: items_chain_boots_trimmed_json },
    { file: "content/items/chain-boots.json", data: items_chain_boots_json },
    { file: "content/items/chain-chausses-elite.json", data: items_chain_chausses_elite_json },
    { file: "content/items/chain-chausses-trimmed.json", data: items_chain_chausses_trimmed_json },
    { file: "content/items/chain-chausses.json", data: items_chain_chausses_json },
    { file: "content/items/chain-coif-elite.json", data: items_chain_coif_elite_json },
    { file: "content/items/chain-coif-trimmed.json", data: items_chain_coif_trimmed_json },
    { file: "content/items/chain-coif.json", data: items_chain_coif_json },
    { file: "content/items/chain-hauberk-elite.json", data: items_chain_hauberk_elite_json },
    { file: "content/items/chain-hauberk-trimmed.json", data: items_chain_hauberk_trimmed_json },
    { file: "content/items/chain-hauberk.json", data: items_chain_hauberk_json },
    { file: "content/items/cloak.json", data: items_cloak_json },
    { file: "content/items/cloth-pants.json", data: items_cloth_pants_json },
    { file: "content/items/cooked-meat.json", data: items_cooked_meat_json },
    { file: "content/items/cooked-minnow.json", data: items_cooked_minnow_json },
    { file: "content/items/cooked-perch.json", data: items_cooked_perch_json },
    { file: "content/items/cooked-pike.json", data: items_cooked_pike_json },
    { file: "content/items/cooked-trout.json", data: items_cooked_trout_json },
    { file: "content/items/cooked-venison.json", data: items_cooked_venison_json },
    { file: "content/items/cup.json", data: items_cup_json },
    { file: "content/items/fermenter.json", data: items_fermenter_json },
    { file: "content/items/fishing-net.json", data: items_fishing_net_json },
    { file: "content/items/fishing-rod.json", data: items_fishing_rod_json },
    { file: "content/items/flower.json", data: items_flower_json },
    { file: "content/items/goblin-token.json", data: items_goblin_token_json },
    { file: "content/items/greatsword.json", data: items_greatsword_json },
    { file: "content/items/hatchet.json", data: items_hatchet_json },
    { file: "content/items/hide.json", data: items_hide_json },
    { file: "content/items/hooded-cloak.json", data: items_hooded_cloak_json },
    { file: "content/items/hunting-bow.json", data: items_hunting_bow_json },
    { file: "content/items/iron-boots.json", data: items_iron_boots_json },
    { file: "content/items/iron-helm.json", data: items_iron_helm_json },
    { file: "content/items/kindling.json", data: items_kindling_json },
    { file: "content/items/leather-boots-elite.json", data: items_leather_boots_elite_json },
    { file: "content/items/leather-boots-trimmed.json", data: items_leather_boots_trimmed_json },
    { file: "content/items/leather-boots.json", data: items_leather_boots_json },
    { file: "content/items/leather-cap-elite.json", data: items_leather_cap_elite_json },
    { file: "content/items/leather-cap-trimmed.json", data: items_leather_cap_trimmed_json },
    { file: "content/items/leather-cap.json", data: items_leather_cap_json },
    { file: "content/items/leather-greaves-elite.json", data: items_leather_greaves_elite_json },
    { file: "content/items/leather-greaves-trimmed.json", data: items_leather_greaves_trimmed_json },
    { file: "content/items/leather-greaves.json", data: items_leather_greaves_json },
    { file: "content/items/leather-jerkin-elite.json", data: items_leather_jerkin_elite_json },
    { file: "content/items/leather-jerkin-trimmed.json", data: items_leather_jerkin_trimmed_json },
    { file: "content/items/leather-jerkin.json", data: items_leather_jerkin_json },
    { file: "content/items/leather-shoes.json", data: items_leather_shoes_json },
    { file: "content/items/longbow.json", data: items_longbow_json },
    { file: "content/items/minnow.json", data: items_minnow_json },
    { file: "content/items/oak-logs.json", data: items_oak_logs_json },
    { file: "content/items/obol.json", data: items_obol_json },
    { file: "content/items/padded-chausses-elite.json", data: items_padded_chausses_elite_json },
    { file: "content/items/padded-chausses-trimmed.json", data: items_padded_chausses_trimmed_json },
    { file: "content/items/padded-chausses.json", data: items_padded_chausses_json },
    { file: "content/items/padded-coif-elite.json", data: items_padded_coif_elite_json },
    { file: "content/items/padded-coif-trimmed.json", data: items_padded_coif_trimmed_json },
    { file: "content/items/padded-coif.json", data: items_padded_coif_json },
    { file: "content/items/padded-jack-elite.json", data: items_padded_jack_elite_json },
    { file: "content/items/padded-jack-trimmed.json", data: items_padded_jack_trimmed_json },
    { file: "content/items/padded-jack.json", data: items_padded_jack_json },
    { file: "content/items/padded-shoes-elite.json", data: items_padded_shoes_elite_json },
    { file: "content/items/padded-shoes-trimmed.json", data: items_padded_shoes_trimmed_json },
    { file: "content/items/padded-shoes.json", data: items_padded_shoes_json },
    { file: "content/items/perch.json", data: items_perch_json },
    { file: "content/items/pike.json", data: items_pike_json },
    { file: "content/items/pine-logs.json", data: items_pine_logs_json },
    { file: "content/items/pinecone.json", data: items_pinecone_json },
    { file: "content/items/plate-boots-elite.json", data: items_plate_boots_elite_json },
    { file: "content/items/plate-boots-trimmed.json", data: items_plate_boots_trimmed_json },
    { file: "content/items/plate-cuirass-elite.json", data: items_plate_cuirass_elite_json },
    { file: "content/items/plate-cuirass-trimmed.json", data: items_plate_cuirass_trimmed_json },
    { file: "content/items/plate-cuirass.json", data: items_plate_cuirass_json },
    { file: "content/items/plate-greaves-elite.json", data: items_plate_greaves_elite_json },
    { file: "content/items/plate-greaves-trimmed.json", data: items_plate_greaves_trimmed_json },
    { file: "content/items/plate-greaves.json", data: items_plate_greaves_json },
    { file: "content/items/plate-helm-elite.json", data: items_plate_helm_elite_json },
    { file: "content/items/plate-helm-trimmed.json", data: items_plate_helm_trimmed_json },
    { file: "content/items/preserves.json", data: items_preserves_json },
    { file: "content/items/raw-meat.json", data: items_raw_meat_json },
    { file: "content/items/round-shield.json", data: items_round_shield_json },
    { file: "content/items/rusty-sword.json", data: items_rusty_sword_json },
    { file: "content/items/scout-harness-elite.json", data: items_scout_harness_elite_json },
    { file: "content/items/scout-harness-trimmed.json", data: items_scout_harness_trimmed_json },
    { file: "content/items/scout-harness.json", data: items_scout_harness_json },
    { file: "content/items/scout-hood-elite.json", data: items_scout_hood_elite_json },
    { file: "content/items/scout-hood-trimmed.json", data: items_scout_hood_trimmed_json },
    { file: "content/items/scout-hood.json", data: items_scout_hood_json },
    { file: "content/items/scout-wraps-elite.json", data: items_scout_wraps_elite_json },
    { file: "content/items/scout-wraps-trimmed.json", data: items_scout_wraps_trimmed_json },
    { file: "content/items/scout-wraps.json", data: items_scout_wraps_json },
    { file: "content/items/shortbow.json", data: items_shortbow_json },
    { file: "content/items/shorts.json", data: items_shorts_json },
    { file: "content/items/silver-fox-pelt.json", data: items_silver_fox_pelt_json },
    { file: "content/items/snare-trap.json", data: items_snare_trap_json },
    { file: "content/items/spear.json", data: items_spear_json },
    { file: "content/items/stag-antlers.json", data: items_stag_antlers_json },
    { file: "content/items/straw-hat.json", data: items_straw_hat_json },
    { file: "content/items/sword.json", data: items_sword_json },
    { file: "content/items/trail-shoes-elite.json", data: items_trail_shoes_elite_json },
    { file: "content/items/trail-shoes-trimmed.json", data: items_trail_shoes_trimmed_json },
    { file: "content/items/trail-shoes.json", data: items_trail_shoes_json },
    { file: "content/items/trout.json", data: items_trout_json },
    { file: "content/items/tunic-short.json", data: items_tunic_short_json },
    { file: "content/items/tunic.json", data: items_tunic_json },
    { file: "content/items/venison.json", data: items_venison_json },
    { file: "content/items/wooden-arrow.json", data: items_wooden_arrow_json },
    { file: "content/items/wooden-bow.json", data: items_wooden_bow_json },
    { file: "content/items/wool-cape.json", data: items_wool_cape_json },
  ] as RawEntry[],
  "models": [
    { file: "content/models/ale.json", data: models_ale_json },
    { file: "content/models/angler.json", data: models_angler_json },
    { file: "content/models/axe.json", data: models_axe_json },
    { file: "content/models/birch-logs.json", data: models_birch_logs_json },
    { file: "content/models/boat.json", data: models_boat_json },
    { file: "content/models/boatman.json", data: models_boatman_json },
    { file: "content/models/bram.json", data: models_bram_json },
    { file: "content/models/burnt-mess.json", data: models_burnt_mess_json },
    { file: "content/models/chicken.json", data: models_chicken_json },
    { file: "content/models/cloth-pants.json", data: models_cloth_pants_json },
    { file: "content/models/cooked-meat.json", data: models_cooked_meat_json },
    { file: "content/models/cooked-minnow.json", data: models_cooked_minnow_json },
    { file: "content/models/cooked-perch.json", data: models_cooked_perch_json },
    { file: "content/models/cooked-pike.json", data: models_cooked_pike_json },
    { file: "content/models/cooked-trout.json", data: models_cooked_trout_json },
    { file: "content/models/cooked-venison.json", data: models_cooked_venison_json },
    { file: "content/models/cow.json", data: models_cow_json },
    { file: "content/models/cup.json", data: models_cup_json },
    { file: "content/models/deer.json", data: models_deer_json },
    { file: "content/models/dekkar.json", data: models_dekkar_json },
    { file: "content/models/fermenter.json", data: models_fermenter_json },
    { file: "content/models/fishing-net.json", data: models_fishing_net_json },
    { file: "content/models/fishing-rod.json", data: models_fishing_rod_json },
    { file: "content/models/fishmonger.json", data: models_fishmonger_json },
    { file: "content/models/fox.json", data: models_fox_json },
    { file: "content/models/goblin-archer.json", data: models_goblin_archer_json },
    { file: "content/models/goblin-token.json", data: models_goblin_token_json },
    { file: "content/models/goblin.json", data: models_goblin_json },
    { file: "content/models/greatsword.json", data: models_greatsword_json },
    { file: "content/models/hatchet.json", data: models_hatchet_json },
    { file: "content/models/hide.json", data: models_hide_json },
    { file: "content/models/horse.json", data: models_horse_json },
    { file: "content/models/hunting-bow.json", data: models_hunting_bow_json },
    { file: "content/models/huntsman.json", data: models_huntsman_json },
    { file: "content/models/kindling.json", data: models_kindling_json },
    { file: "content/models/king.json", data: models_king_json },
    { file: "content/models/leather-shoes.json", data: models_leather_shoes_json },
    { file: "content/models/lila.json", data: models_lila_json },
    { file: "content/models/longbow.json", data: models_longbow_json },
    { file: "content/models/minnow.json", data: models_minnow_json },
    { file: "content/models/mira.json", data: models_mira_json },
    { file: "content/models/oak-logs.json", data: models_oak_logs_json },
    { file: "content/models/obol.json", data: models_obol_json },
    { file: "content/models/perch.json", data: models_perch_json },
    { file: "content/models/pig.json", data: models_pig_json },
    { file: "content/models/pike.json", data: models_pike_json },
    { file: "content/models/pine-logs.json", data: models_pine_logs_json },
    { file: "content/models/pinecone.json", data: models_pinecone_json },
    { file: "content/models/player.json", data: models_player_json },
    { file: "content/models/preserves.json", data: models_preserves_json },
    { file: "content/models/rabbit.json", data: models_rabbit_json },
    { file: "content/models/raw-meat.json", data: models_raw_meat_json },
    { file: "content/models/round-shield.json", data: models_round_shield_json },
    { file: "content/models/rusty-sword.json", data: models_rusty_sword_json },
    { file: "content/models/sheep.json", data: models_sheep_json },
    { file: "content/models/shopkeeper.json", data: models_shopkeeper_json },
    { file: "content/models/shortbow.json", data: models_shortbow_json },
    { file: "content/models/shorts.json", data: models_shorts_json },
    { file: "content/models/silver-fox-pelt.json", data: models_silver_fox_pelt_json },
    { file: "content/models/snare-trap.json", data: models_snare_trap_json },
    { file: "content/models/spear.json", data: models_spear_json },
    { file: "content/models/spider.json", data: models_spider_json },
    { file: "content/models/stag-antlers.json", data: models_stag_antlers_json },
    { file: "content/models/storekeeper.json", data: models_storekeeper_json },
    { file: "content/models/sword.json", data: models_sword_json },
    { file: "content/models/tanner.json", data: models_tanner_json },
    { file: "content/models/town-guard.json", data: models_town_guard_json },
    { file: "content/models/townsman.json", data: models_townsman_json },
    { file: "content/models/trout.json", data: models_trout_json },
    { file: "content/models/tunic-short.json", data: models_tunic_short_json },
    { file: "content/models/tunic.json", data: models_tunic_json },
    { file: "content/models/venison.json", data: models_venison_json },
    { file: "content/models/villager.json", data: models_villager_json },
    { file: "content/models/wolf.json", data: models_wolf_json },
    { file: "content/models/wooden-arrow.json", data: models_wooden_arrow_json },
    { file: "content/models/wooden-bow.json", data: models_wooden_bow_json },
  ] as RawEntry[],
  "decos": [
    { file: "content/decos/barrel.json", data: decos_barrel_json },
    { file: "content/decos/bench.json", data: decos_bench_json },
    { file: "content/decos/birch.json", data: decos_birch_json },
    { file: "content/decos/boulder.json", data: decos_boulder_json },
    { file: "content/decos/bush.json", data: decos_bush_json },
    { file: "content/decos/campfire.json", data: decos_campfire_json },
    { file: "content/decos/cattail.json", data: decos_cattail_json },
    { file: "content/decos/chest.json", data: decos_chest_json },
    { file: "content/decos/crate.json", data: decos_crate_json },
    { file: "content/decos/driftwood.json", data: decos_driftwood_json },
    { file: "content/decos/drying-rack.json", data: decos_drying_rack_json },
    { file: "content/decos/fence.json", data: decos_fence_json },
    { file: "content/decos/fern.json", data: decos_fern_json },
    { file: "content/decos/flower.json", data: decos_flower_json },
    { file: "content/decos/grass.json", data: decos_grass_json },
    { file: "content/decos/hanging-net.json", data: decos_hanging_net_json },
    { file: "content/decos/hide-frame.json", data: decos_hide_frame_json },
    { file: "content/decos/lantern-post.json", data: decos_lantern_post_json },
    { file: "content/decos/laundry-line.json", data: decos_laundry_line_json },
    { file: "content/decos/lilypad.json", data: decos_lilypad_json },
    { file: "content/decos/log.json", data: decos_log_json },
    { file: "content/decos/mushroom.json", data: decos_mushroom_json },
    { file: "content/decos/net-shed.json", data: decos_net_shed_json },
    { file: "content/decos/notice-board.json", data: decos_notice_board_json },
    { file: "content/decos/pine.json", data: decos_pine_json },
    { file: "content/decos/planter.json", data: decos_planter_json },
    { file: "content/decos/rain-barrel.json", data: decos_rain_barrel_json },
    { file: "content/decos/range.json", data: decos_range_json },
    { file: "content/decos/rock.json", data: decos_rock_json },
    { file: "content/decos/signpost.json", data: decos_signpost_json },
    { file: "content/decos/stump.json", data: decos_stump_json },
    { file: "content/decos/tree.json", data: decos_tree_json },
    { file: "content/decos/well.json", data: decos_well_json },
    { file: "content/decos/woodpile.json", data: decos_woodpile_json },
  ] as RawEntry[],
  "parts": [
    { file: "content/parts/backpack.json", data: parts_backpack_json },
    { file: "content/parts/beard-gray.json", data: parts_beard_gray_json },
    { file: "content/parts/beard-white.json", data: parts_beard_white_json },
    { file: "content/parts/chain-boots-elite.json", data: parts_chain_boots_elite_json },
    { file: "content/parts/chain-boots-trimmed.json", data: parts_chain_boots_trimmed_json },
    { file: "content/parts/chain-boots.json", data: parts_chain_boots_json },
    { file: "content/parts/chain-chausses-elite.json", data: parts_chain_chausses_elite_json },
    { file: "content/parts/chain-chausses-trimmed.json", data: parts_chain_chausses_trimmed_json },
    { file: "content/parts/chain-chausses.json", data: parts_chain_chausses_json },
    { file: "content/parts/chain-coif-elite.json", data: parts_chain_coif_elite_json },
    { file: "content/parts/chain-coif-trimmed.json", data: parts_chain_coif_trimmed_json },
    { file: "content/parts/chain-coif.json", data: parts_chain_coif_json },
    { file: "content/parts/chain-hauberk-elite.json", data: parts_chain_hauberk_elite_json },
    { file: "content/parts/chain-hauberk-trimmed.json", data: parts_chain_hauberk_trimmed_json },
    { file: "content/parts/chain-hauberk.json", data: parts_chain_hauberk_json },
    { file: "content/parts/cloak.json", data: parts_cloak_json },
    { file: "content/parts/goblin-face.json", data: parts_goblin_face_json },
    { file: "content/parts/gold-crown.json", data: parts_gold_crown_json },
    { file: "content/parts/hooded-cloak.json", data: parts_hooded_cloak_json },
    { file: "content/parts/iron-boots.json", data: parts_iron_boots_json },
    { file: "content/parts/iron-helm.json", data: parts_iron_helm_json },
    { file: "content/parts/leather-boots-elite.json", data: parts_leather_boots_elite_json },
    { file: "content/parts/leather-boots-trimmed.json", data: parts_leather_boots_trimmed_json },
    { file: "content/parts/leather-boots.json", data: parts_leather_boots_json },
    { file: "content/parts/leather-cap-elite.json", data: parts_leather_cap_elite_json },
    { file: "content/parts/leather-cap-trimmed.json", data: parts_leather_cap_trimmed_json },
    { file: "content/parts/leather-cap.json", data: parts_leather_cap_json },
    { file: "content/parts/leather-greaves-elite.json", data: parts_leather_greaves_elite_json },
    { file: "content/parts/leather-greaves-trimmed.json", data: parts_leather_greaves_trimmed_json },
    { file: "content/parts/leather-greaves.json", data: parts_leather_greaves_json },
    { file: "content/parts/leather-jerkin-elite.json", data: parts_leather_jerkin_elite_json },
    { file: "content/parts/leather-jerkin-trimmed.json", data: parts_leather_jerkin_trimmed_json },
    { file: "content/parts/leather-jerkin.json", data: parts_leather_jerkin_json },
    { file: "content/parts/padded-chausses-elite.json", data: parts_padded_chausses_elite_json },
    { file: "content/parts/padded-chausses-trimmed.json", data: parts_padded_chausses_trimmed_json },
    { file: "content/parts/padded-chausses.json", data: parts_padded_chausses_json },
    { file: "content/parts/padded-coif-elite.json", data: parts_padded_coif_elite_json },
    { file: "content/parts/padded-coif-trimmed.json", data: parts_padded_coif_trimmed_json },
    { file: "content/parts/padded-coif.json", data: parts_padded_coif_json },
    { file: "content/parts/padded-jack-elite.json", data: parts_padded_jack_elite_json },
    { file: "content/parts/padded-jack-trimmed.json", data: parts_padded_jack_trimmed_json },
    { file: "content/parts/padded-jack.json", data: parts_padded_jack_json },
    { file: "content/parts/padded-shoes-elite.json", data: parts_padded_shoes_elite_json },
    { file: "content/parts/padded-shoes-trimmed.json", data: parts_padded_shoes_trimmed_json },
    { file: "content/parts/padded-shoes.json", data: parts_padded_shoes_json },
    { file: "content/parts/plate-boots-elite.json", data: parts_plate_boots_elite_json },
    { file: "content/parts/plate-boots-trimmed.json", data: parts_plate_boots_trimmed_json },
    { file: "content/parts/plate-cuirass-elite.json", data: parts_plate_cuirass_elite_json },
    { file: "content/parts/plate-cuirass-trimmed.json", data: parts_plate_cuirass_trimmed_json },
    { file: "content/parts/plate-cuirass.json", data: parts_plate_cuirass_json },
    { file: "content/parts/plate-greaves-elite.json", data: parts_plate_greaves_elite_json },
    { file: "content/parts/plate-greaves-trimmed.json", data: parts_plate_greaves_trimmed_json },
    { file: "content/parts/plate-greaves.json", data: parts_plate_greaves_json },
    { file: "content/parts/plate-helm-elite.json", data: parts_plate_helm_elite_json },
    { file: "content/parts/plate-helm-trimmed.json", data: parts_plate_helm_trimmed_json },
    { file: "content/parts/plumed-helm.json", data: parts_plumed_helm_json },
    { file: "content/parts/royal-cape.json", data: parts_royal_cape_json },
    { file: "content/parts/scout-harness-elite.json", data: parts_scout_harness_elite_json },
    { file: "content/parts/scout-harness-trimmed.json", data: parts_scout_harness_trimmed_json },
    { file: "content/parts/scout-harness.json", data: parts_scout_harness_json },
    { file: "content/parts/scout-hood-elite.json", data: parts_scout_hood_elite_json },
    { file: "content/parts/scout-hood-trimmed.json", data: parts_scout_hood_trimmed_json },
    { file: "content/parts/scout-hood.json", data: parts_scout_hood_json },
    { file: "content/parts/scout-wraps-elite.json", data: parts_scout_wraps_elite_json },
    { file: "content/parts/scout-wraps-trimmed.json", data: parts_scout_wraps_trimmed_json },
    { file: "content/parts/scout-wraps.json", data: parts_scout_wraps_json },
    { file: "content/parts/straw-hat.json", data: parts_straw_hat_json },
    { file: "content/parts/trail-shoes-elite.json", data: parts_trail_shoes_elite_json },
    { file: "content/parts/trail-shoes-trimmed.json", data: parts_trail_shoes_trimmed_json },
    { file: "content/parts/trail-shoes.json", data: parts_trail_shoes_json },
    { file: "content/parts/wool-cape.json", data: parts_wool_cape_json },
  ] as RawEntry[],
  "structures": [
    { file: "content/structures/chapel.json", data: structures_chapel_json },
    { file: "content/structures/fishing-dock.json", data: structures_fishing_dock_json },
    { file: "content/structures/general-store.json", data: structures_general_store_json },
    { file: "content/structures/log-house.json", data: structures_log_house_json },
    { file: "content/structures/market-pavilion.json", data: structures_market_pavilion_json },
    { file: "content/structures/shed.json", data: structures_shed_json },
    { file: "content/structures/standard-house.json", data: structures_standard_house_json },
    { file: "content/structures/stone-arch.json", data: structures_stone_arch_json },
  ] as RawEntry[],
  "shops": [
    { file: "content/shops/castle-armory.json", data: shops_castle_armory_json },
    { file: "content/shops/fish-market.json", data: shops_fish_market_json },
    { file: "content/shops/general-store.json", data: shops_general_store_json },
    { file: "content/shops/huntsman-lodge.json", data: shops_huntsman_lodge_json },
    { file: "content/shops/kitchen.json", data: shops_kitchen_json },
  ] as RawEntry[],
  "skills": [
    { file: "content/skills/combat.json", data: skills_combat_json },
    { file: "content/skills/cooking.json", data: skills_cooking_json },
    { file: "content/skills/fishing.json", data: skills_fishing_json },
    { file: "content/skills/hunting.json", data: skills_hunting_json },
  ] as RawEntry[],
  "standing": [
    { file: "content/standing/cooks.json", data: standing_cooks_json },
    { file: "content/standing/crown.json", data: standing_crown_json },
    { file: "content/standing/fishmongers.json", data: standing_fishmongers_json },
    { file: "content/standing/huntsmen.json", data: standing_huntsmen_json },
  ] as RawEntry[],
  "moves": [
    { file: "content/moves/bash.json", data: moves_bash_json },
    { file: "content/moves/heavy-strike.json", data: moves_heavy_strike_json },
    { file: "content/moves/leg-sweep.json", data: moves_leg_sweep_json },
    { file: "content/moves/pierce.json", data: moves_pierce_json },
    { file: "content/moves/power-shot.json", data: moves_power_shot_json },
    { file: "content/moves/shove.json", data: moves_shove_json },
    { file: "content/moves/slow-arrow.json", data: moves_slow_arrow_json },
    { file: "content/moves/sweep.json", data: moves_sweep_json },
    { file: "content/moves/whirl.json", data: moves_whirl_json },
  ] as RawEntry[],
  "scenarios": [
    { file: "content/scenarios/archer-ambush.json", data: scenarios_archer_ambush_json },
    { file: "content/scenarios/goblin-camp.json", data: scenarios_goblin_camp_json },
    { file: "content/scenarios/guard-rescue.json", data: scenarios_guard_rescue_json },
  ] as RawEntry[],
  "cinematics": [
    { file: "content/cinematics/boat-arrival.json", data: cinematics_boat_arrival_json },
  ] as RawEntry[],
  "catch-tables": [
    { file: "content/catch-tables/netting-bulk.json", data: catch_tables_netting_bulk_json },
  ] as RawEntry[],
  "scatter-palettes": [
    { file: "content/scatter-palettes/forest.json", data: scatter_palettes_forest_json },
    { file: "content/scatter-palettes/rocky-scrub.json", data: scatter_palettes_rocky_scrub_json },
  ] as RawEntry[],
  "tunables": [
    { file: "content/tunables/chopping.json", data: tunables_chopping_json },
    { file: "content/tunables/cooking.json", data: tunables_cooking_json },
    { file: "content/tunables/firestarting.json", data: tunables_firestarting_json },
    { file: "content/tunables/fishing.json", data: tunables_fishing_json },
    { file: "content/tunables/hunting.json", data: tunables_hunting_json },
  ] as RawEntry[],
  "maps": [
    { file: "content/maps/arena-test.json", data: maps_arena_test_json },
    { file: "content/maps/east-marches.json", data: maps_east_marches_json },
    { file: "content/maps/overworld.json", data: maps_overworld_json },
    { file: "content/maps/testing.json", data: maps_testing_json },
    { file: "content/maps/tutorial-south.json", data: maps_tutorial_south_json },
    { file: "content/maps/tutorial-west.json", data: maps_tutorial_west_json },
    { file: "content/maps/tutorial.json", data: maps_tutorial_json },
  ] as RawEntry[],
  world: { file: "content/world/factions.json", data: world_factions_json } as RawEntry | null,
  anim: { file: "content/anim/clips.json", data: anim_clips_json } as RawEntry | null,
};

/** Every content file baked into this manifest (staleness check in load.ts). */
export const MANIFEST_FILES: string[] = [
  "content/quests/soft-landing.json",
  "content/quests/wolf-hunt.json",
  "content/npcs/angler.json",
  "content/npcs/boat.json",
  "content/npcs/boatman.json",
  "content/npcs/bram.json",
  "content/npcs/chicken.json",
  "content/npcs/cook.json",
  "content/npcs/cow.json",
  "content/npcs/deer.json",
  "content/npcs/dekkar.json",
  "content/npcs/edric.json",
  "content/npcs/fishmonger.json",
  "content/npcs/fox.json",
  "content/npcs/goblin-archer.json",
  "content/npcs/goblin.json",
  "content/npcs/grizzlespit.json",
  "content/npcs/guard.json",
  "content/npcs/horse.json",
  "content/npcs/huntsman.json",
  "content/npcs/king.json",
  "content/npcs/lila.json",
  "content/npcs/mira.json",
  "content/npcs/pig.json",
  "content/npcs/rabbit.json",
  "content/npcs/scrawny-wolf.json",
  "content/npcs/sheep.json",
  "content/npcs/shopkeeper.json",
  "content/npcs/spider.json",
  "content/npcs/storekeeper.json",
  "content/npcs/tanner.json",
  "content/npcs/wolf.json",
  "content/items/ale.json",
  "content/items/axe.json",
  "content/items/backpack.json",
  "content/items/birch-logs.json",
  "content/items/burnt-mess.json",
  "content/items/chain-boots-elite.json",
  "content/items/chain-boots-trimmed.json",
  "content/items/chain-boots.json",
  "content/items/chain-chausses-elite.json",
  "content/items/chain-chausses-trimmed.json",
  "content/items/chain-chausses.json",
  "content/items/chain-coif-elite.json",
  "content/items/chain-coif-trimmed.json",
  "content/items/chain-coif.json",
  "content/items/chain-hauberk-elite.json",
  "content/items/chain-hauberk-trimmed.json",
  "content/items/chain-hauberk.json",
  "content/items/cloak.json",
  "content/items/cloth-pants.json",
  "content/items/cooked-meat.json",
  "content/items/cooked-minnow.json",
  "content/items/cooked-perch.json",
  "content/items/cooked-pike.json",
  "content/items/cooked-trout.json",
  "content/items/cooked-venison.json",
  "content/items/cup.json",
  "content/items/fermenter.json",
  "content/items/fishing-net.json",
  "content/items/fishing-rod.json",
  "content/items/flower.json",
  "content/items/goblin-token.json",
  "content/items/greatsword.json",
  "content/items/hatchet.json",
  "content/items/hide.json",
  "content/items/hooded-cloak.json",
  "content/items/hunting-bow.json",
  "content/items/iron-boots.json",
  "content/items/iron-helm.json",
  "content/items/kindling.json",
  "content/items/leather-boots-elite.json",
  "content/items/leather-boots-trimmed.json",
  "content/items/leather-boots.json",
  "content/items/leather-cap-elite.json",
  "content/items/leather-cap-trimmed.json",
  "content/items/leather-cap.json",
  "content/items/leather-greaves-elite.json",
  "content/items/leather-greaves-trimmed.json",
  "content/items/leather-greaves.json",
  "content/items/leather-jerkin-elite.json",
  "content/items/leather-jerkin-trimmed.json",
  "content/items/leather-jerkin.json",
  "content/items/leather-shoes.json",
  "content/items/longbow.json",
  "content/items/minnow.json",
  "content/items/oak-logs.json",
  "content/items/obol.json",
  "content/items/padded-chausses-elite.json",
  "content/items/padded-chausses-trimmed.json",
  "content/items/padded-chausses.json",
  "content/items/padded-coif-elite.json",
  "content/items/padded-coif-trimmed.json",
  "content/items/padded-coif.json",
  "content/items/padded-jack-elite.json",
  "content/items/padded-jack-trimmed.json",
  "content/items/padded-jack.json",
  "content/items/padded-shoes-elite.json",
  "content/items/padded-shoes-trimmed.json",
  "content/items/padded-shoes.json",
  "content/items/perch.json",
  "content/items/pike.json",
  "content/items/pine-logs.json",
  "content/items/pinecone.json",
  "content/items/plate-boots-elite.json",
  "content/items/plate-boots-trimmed.json",
  "content/items/plate-cuirass-elite.json",
  "content/items/plate-cuirass-trimmed.json",
  "content/items/plate-cuirass.json",
  "content/items/plate-greaves-elite.json",
  "content/items/plate-greaves-trimmed.json",
  "content/items/plate-greaves.json",
  "content/items/plate-helm-elite.json",
  "content/items/plate-helm-trimmed.json",
  "content/items/preserves.json",
  "content/items/raw-meat.json",
  "content/items/round-shield.json",
  "content/items/rusty-sword.json",
  "content/items/scout-harness-elite.json",
  "content/items/scout-harness-trimmed.json",
  "content/items/scout-harness.json",
  "content/items/scout-hood-elite.json",
  "content/items/scout-hood-trimmed.json",
  "content/items/scout-hood.json",
  "content/items/scout-wraps-elite.json",
  "content/items/scout-wraps-trimmed.json",
  "content/items/scout-wraps.json",
  "content/items/shortbow.json",
  "content/items/shorts.json",
  "content/items/silver-fox-pelt.json",
  "content/items/snare-trap.json",
  "content/items/spear.json",
  "content/items/stag-antlers.json",
  "content/items/straw-hat.json",
  "content/items/sword.json",
  "content/items/trail-shoes-elite.json",
  "content/items/trail-shoes-trimmed.json",
  "content/items/trail-shoes.json",
  "content/items/trout.json",
  "content/items/tunic-short.json",
  "content/items/tunic.json",
  "content/items/venison.json",
  "content/items/wooden-arrow.json",
  "content/items/wooden-bow.json",
  "content/items/wool-cape.json",
  "content/models/ale.json",
  "content/models/angler.json",
  "content/models/axe.json",
  "content/models/birch-logs.json",
  "content/models/boat.json",
  "content/models/boatman.json",
  "content/models/bram.json",
  "content/models/burnt-mess.json",
  "content/models/chicken.json",
  "content/models/cloth-pants.json",
  "content/models/cooked-meat.json",
  "content/models/cooked-minnow.json",
  "content/models/cooked-perch.json",
  "content/models/cooked-pike.json",
  "content/models/cooked-trout.json",
  "content/models/cooked-venison.json",
  "content/models/cow.json",
  "content/models/cup.json",
  "content/models/deer.json",
  "content/models/dekkar.json",
  "content/models/fermenter.json",
  "content/models/fishing-net.json",
  "content/models/fishing-rod.json",
  "content/models/fishmonger.json",
  "content/models/fox.json",
  "content/models/goblin-archer.json",
  "content/models/goblin-token.json",
  "content/models/goblin.json",
  "content/models/greatsword.json",
  "content/models/hatchet.json",
  "content/models/hide.json",
  "content/models/horse.json",
  "content/models/hunting-bow.json",
  "content/models/huntsman.json",
  "content/models/kindling.json",
  "content/models/king.json",
  "content/models/leather-shoes.json",
  "content/models/lila.json",
  "content/models/longbow.json",
  "content/models/minnow.json",
  "content/models/mira.json",
  "content/models/oak-logs.json",
  "content/models/obol.json",
  "content/models/perch.json",
  "content/models/pig.json",
  "content/models/pike.json",
  "content/models/pine-logs.json",
  "content/models/pinecone.json",
  "content/models/player.json",
  "content/models/preserves.json",
  "content/models/rabbit.json",
  "content/models/raw-meat.json",
  "content/models/round-shield.json",
  "content/models/rusty-sword.json",
  "content/models/sheep.json",
  "content/models/shopkeeper.json",
  "content/models/shortbow.json",
  "content/models/shorts.json",
  "content/models/silver-fox-pelt.json",
  "content/models/snare-trap.json",
  "content/models/spear.json",
  "content/models/spider.json",
  "content/models/stag-antlers.json",
  "content/models/storekeeper.json",
  "content/models/sword.json",
  "content/models/tanner.json",
  "content/models/town-guard.json",
  "content/models/townsman.json",
  "content/models/trout.json",
  "content/models/tunic-short.json",
  "content/models/tunic.json",
  "content/models/venison.json",
  "content/models/villager.json",
  "content/models/wolf.json",
  "content/models/wooden-arrow.json",
  "content/models/wooden-bow.json",
  "content/decos/barrel.json",
  "content/decos/bench.json",
  "content/decos/birch.json",
  "content/decos/boulder.json",
  "content/decos/bush.json",
  "content/decos/campfire.json",
  "content/decos/cattail.json",
  "content/decos/chest.json",
  "content/decos/crate.json",
  "content/decos/driftwood.json",
  "content/decos/drying-rack.json",
  "content/decos/fence.json",
  "content/decos/fern.json",
  "content/decos/flower.json",
  "content/decos/grass.json",
  "content/decos/hanging-net.json",
  "content/decos/hide-frame.json",
  "content/decos/lantern-post.json",
  "content/decos/laundry-line.json",
  "content/decos/lilypad.json",
  "content/decos/log.json",
  "content/decos/mushroom.json",
  "content/decos/net-shed.json",
  "content/decos/notice-board.json",
  "content/decos/pine.json",
  "content/decos/planter.json",
  "content/decos/rain-barrel.json",
  "content/decos/range.json",
  "content/decos/rock.json",
  "content/decos/signpost.json",
  "content/decos/stump.json",
  "content/decos/tree.json",
  "content/decos/well.json",
  "content/decos/woodpile.json",
  "content/parts/backpack.json",
  "content/parts/beard-gray.json",
  "content/parts/beard-white.json",
  "content/parts/chain-boots-elite.json",
  "content/parts/chain-boots-trimmed.json",
  "content/parts/chain-boots.json",
  "content/parts/chain-chausses-elite.json",
  "content/parts/chain-chausses-trimmed.json",
  "content/parts/chain-chausses.json",
  "content/parts/chain-coif-elite.json",
  "content/parts/chain-coif-trimmed.json",
  "content/parts/chain-coif.json",
  "content/parts/chain-hauberk-elite.json",
  "content/parts/chain-hauberk-trimmed.json",
  "content/parts/chain-hauberk.json",
  "content/parts/cloak.json",
  "content/parts/goblin-face.json",
  "content/parts/gold-crown.json",
  "content/parts/hooded-cloak.json",
  "content/parts/iron-boots.json",
  "content/parts/iron-helm.json",
  "content/parts/leather-boots-elite.json",
  "content/parts/leather-boots-trimmed.json",
  "content/parts/leather-boots.json",
  "content/parts/leather-cap-elite.json",
  "content/parts/leather-cap-trimmed.json",
  "content/parts/leather-cap.json",
  "content/parts/leather-greaves-elite.json",
  "content/parts/leather-greaves-trimmed.json",
  "content/parts/leather-greaves.json",
  "content/parts/leather-jerkin-elite.json",
  "content/parts/leather-jerkin-trimmed.json",
  "content/parts/leather-jerkin.json",
  "content/parts/padded-chausses-elite.json",
  "content/parts/padded-chausses-trimmed.json",
  "content/parts/padded-chausses.json",
  "content/parts/padded-coif-elite.json",
  "content/parts/padded-coif-trimmed.json",
  "content/parts/padded-coif.json",
  "content/parts/padded-jack-elite.json",
  "content/parts/padded-jack-trimmed.json",
  "content/parts/padded-jack.json",
  "content/parts/padded-shoes-elite.json",
  "content/parts/padded-shoes-trimmed.json",
  "content/parts/padded-shoes.json",
  "content/parts/plate-boots-elite.json",
  "content/parts/plate-boots-trimmed.json",
  "content/parts/plate-cuirass-elite.json",
  "content/parts/plate-cuirass-trimmed.json",
  "content/parts/plate-cuirass.json",
  "content/parts/plate-greaves-elite.json",
  "content/parts/plate-greaves-trimmed.json",
  "content/parts/plate-greaves.json",
  "content/parts/plate-helm-elite.json",
  "content/parts/plate-helm-trimmed.json",
  "content/parts/plumed-helm.json",
  "content/parts/royal-cape.json",
  "content/parts/scout-harness-elite.json",
  "content/parts/scout-harness-trimmed.json",
  "content/parts/scout-harness.json",
  "content/parts/scout-hood-elite.json",
  "content/parts/scout-hood-trimmed.json",
  "content/parts/scout-hood.json",
  "content/parts/scout-wraps-elite.json",
  "content/parts/scout-wraps-trimmed.json",
  "content/parts/scout-wraps.json",
  "content/parts/straw-hat.json",
  "content/parts/trail-shoes-elite.json",
  "content/parts/trail-shoes-trimmed.json",
  "content/parts/trail-shoes.json",
  "content/parts/wool-cape.json",
  "content/structures/chapel.json",
  "content/structures/fishing-dock.json",
  "content/structures/general-store.json",
  "content/structures/log-house.json",
  "content/structures/market-pavilion.json",
  "content/structures/shed.json",
  "content/structures/standard-house.json",
  "content/structures/stone-arch.json",
  "content/shops/castle-armory.json",
  "content/shops/fish-market.json",
  "content/shops/general-store.json",
  "content/shops/huntsman-lodge.json",
  "content/shops/kitchen.json",
  "content/skills/combat.json",
  "content/skills/cooking.json",
  "content/skills/fishing.json",
  "content/skills/hunting.json",
  "content/standing/cooks.json",
  "content/standing/crown.json",
  "content/standing/fishmongers.json",
  "content/standing/huntsmen.json",
  "content/moves/bash.json",
  "content/moves/heavy-strike.json",
  "content/moves/leg-sweep.json",
  "content/moves/pierce.json",
  "content/moves/power-shot.json",
  "content/moves/shove.json",
  "content/moves/slow-arrow.json",
  "content/moves/sweep.json",
  "content/moves/whirl.json",
  "content/scenarios/archer-ambush.json",
  "content/scenarios/goblin-camp.json",
  "content/scenarios/guard-rescue.json",
  "content/cinematics/boat-arrival.json",
  "content/catch-tables/netting-bulk.json",
  "content/scatter-palettes/forest.json",
  "content/scatter-palettes/rocky-scrub.json",
  "content/tunables/chopping.json",
  "content/tunables/cooking.json",
  "content/tunables/firestarting.json",
  "content/tunables/fishing.json",
  "content/tunables/hunting.json",
  "content/maps/arena-test.json",
  "content/maps/east-marches.json",
  "content/maps/overworld.json",
  "content/maps/testing.json",
  "content/maps/tutorial-south.json",
  "content/maps/tutorial-west.json",
  "content/maps/tutorial.json",
  "content/world/factions.json",
  "content/anim/clips.json"
];
